import { render, staticRenderFns } from "./verifiedIDCard.vue?vue&type=template&id=0ef7decc&scoped=true&"
import script from "./verifiedIDCard.vue?vue&type=script&lang=js&"
export * from "./verifiedIDCard.vue?vue&type=script&lang=js&"
import style0 from "./verifiedIDCard.vue?vue&type=style&index=0&id=0ef7decc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef7decc",
  null
  
)

export default component.exports